// extracted by mini-css-extract-plugin
module.exports = {"firstConatiner":"FileUpload_firstConatiner__2vjqT","customFileUpload":"FileUpload_customFileUpload__2RLQI"};